module.exports = __webpack_public_path__ + "static/img/logo@2x.c947bd3c.png";